import store from '@/store';

export function translate(translationKey) {
  let a = store.state.data.Translations[translationKey];
  let storedLanguage = store.state.app.language;
  if (storedLanguage && storedLanguage === 'el') { // on table translations, we have gr instead of el
    storedLanguage = 'gr';
  }
  // console.log(this.$store);
  // console.log(a);
  // console.log(store.state.app.language);
  if (a && a[storedLanguage]) {
    // console.log(a[storedLanguage]);
    return a[storedLanguage];
  } else {
    return translationKey;
  }
}

export function translateCapital(translationKey) {
  let a = store.state.data.Translations[translationKey];
  let storedLanguage = store.state.app.language;
  if (storedLanguage && storedLanguage === 'el') { // on table translations, we have gr instead of el
    storedLanguage = 'gr';
  }
  // console.log(this.$store);
  // console.log(a);
  // console.log(store.state.app.language);
  if (a && a[storedLanguage]) {
    // console.log(a[storedLanguage]);
    return a[storedLanguage].normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  } else {
    return translationKey.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();
  }
}



// WEBPACK FOOTER //
// ./src/utils/translate.js